<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="차량선택"
                [(ngModel)]="dtgCarNo"
                (click)="clickOpenModalCarSearch(DtgActionType.read)"
                readonly>
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickOpenModalCarSearch(DtgActionType.read)">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        차량검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="date" class="form-control form-control-sm"
                placeholder="2021-01-01"
                (ngModelChange)="changeRegDtFrom($event)"
                [(ngModel)]="regDtFrom">
            <div class="input-group-append">
                <span class="input-group-text">
                    부터
                </span>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="date" class="form-control form-control-sm"
                placeholder="2021-01-01"
                (ngModelChange)="changeRegDtTo($event)"
                [(ngModel)]="regDtTo">
            <div class="input-group-append">
                <span class="input-group-text">
                    까지
                </span>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickSearch()">
            <i class="fas fa-search"></i>
            <span class="ml-1">
                파일생성요청
            </span>
        </button>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="loadFileCreateHist()">
            <i class="fas fa-search"></i>
            <span class="ml-1">
                파일검색
            </span>
        </button>
    </div>
    <div class="col"></div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead>
            <tr>
                <th>
                    파일명
                </th>
                <th>
                    상태
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="!listFileCreateHist">
                <tr>
                    <td colspan="2">
                        표시 할 항목이 없습니다
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngFor="let item of listFileCreateHist;">
                <tr>
                    <td>
                        <span role="button" class="text-cyan"
                            (click)="clickSelectFile(item)">
                            {{item.fileName}}
                        </span>
                    </td>
                    <td>
                        {{item.stepMsg}}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>